import axios from "@/lib/axios";
import { useMutation } from "@tanstack/vue-query";
import useCustomMutation from "@/composables/useCustomMutation";
import { MutationParams } from "@/interfaces/mutationParams";
import { useToast } from "vue-toastification";

interface CreateParams {
  companyId: number;
  media: File;
  collection: string;
}

const createCompanyMedia = async (params: CreateParams) => {
  const { companyId, media, collection } = params;
  const formData = new FormData();
  formData.append("media", media);
  formData.append("collection", collection);
  const { data } = await axios.post(
    `/api/companies/${companyId}/medias`,
    formData
  );
  return data;
};

const useCompanyMedia = () => {
  const toast = useToast();

  const createMutation = useMutation(
    ({ params }: MutationParams<CreateParams>) => createCompanyMedia(params),
    useCustomMutation(toast, "create")
  );

  return {
    companyMediaCreateMutation: createMutation,
    companyMediaCreate: createMutation.mutate,
    companyMediaCreateAsync: createMutation.mutateAsync,
  };
};

export default useCompanyMedia;
